module.exports = __webpack_public_path__ + "static/media/Wed2.5b53fa70.jpg";